import { makeStyles } from '@material-ui/core'
import {
  CheckCircle as CheckCircleIcon,
  DescriptionOutlined as DescriptionIcon,
  Visibility as VisibilityIcon,
  MessageOutlined as MessageIcon,
  Star as StarIcon,
  StarOutline as StarOutlineIcon,
} from '@material-ui/icons'
import clsx from 'clsx'
import React from 'react'

import { useActionRunner } from 'src/modules/notification'
import { Button } from 'src/modules/ui'

import MessageSupplierModal from '../../messages/components/MessageSupplierModal'
import { useSuppliers } from '../hooks'

const useStyles = makeStyles(theme => ({
  actions: {
    '& > *': {
      marginBottom: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      '&:last-child': {
        marginRight: theme.spacing(0),
      },
    },
  },
}))

const SupplierActions = ({
  canMessage,
  canRequestAgreement,
  canStar,
  className,
  ...supplier
}) => {
  const { id, proposalStatus, starred } = supplier

  const classes = useStyles()
  const { starSupplier, unstarSupplier, requestProposal } = useSuppliers()

  const [doStarSupplier] = useActionRunner(starSupplier)
  const [doUnstarSupplier] = useActionRunner(unstarSupplier)
  const [doRequestProposal] = useActionRunner(requestProposal)

  const preventDefault = fn => (event, ...args) => {
    event.preventDefault()
    return fn && fn(event, ...args)
  }

  return (
    <div className={clsx(classes.actions, className)}>
      {canStar &&
        (starred ? (
          <Button
            color="secondary"
            onClick={preventDefault(() => doUnstarSupplier(id))}
            size="small"
            startIcon={<StarIcon />}
          >
            Favourited
          </Button>
        ) : (
          <Button
            color="primary"
            onClick={preventDefault(() => doStarSupplier(id))}
            startIcon={<StarOutlineIcon />}
            size="small"
          >
            Favourite
          </Button>
        ))}
      {canMessage && (
        <MessageSupplierModal
          onClick={preventDefault()}
          supplier={supplier}
          trigger={({ onClick }) => (
            <Button
              color="primary"
              onClick={preventDefault(onClick)}
              size="small"
              startIcon={<MessageIcon />}
            >
              Message
            </Button>
          )}
        />
      )}
      {canRequestAgreement &&
        (proposalStatus === 'requested' ? (
          <Button
            color="darkGreen"
            size="small"
            startIcon={<DescriptionIcon />}
          >
            Proposal Requested
          </Button>
        ) : proposalStatus === 'proposed' ? (
          <Button color="orange" size="small" startIcon={<VisibilityIcon />}>
            Proposal Received
          </Button>
        ) : proposalStatus === 'accepted' ? (
          <Button
            color="lightGreen"
            size="small"
            startIcon={<CheckCircleIcon />}
          >
            Approved Supplier
          </Button>
        ) : (
          <Button
            color="primary"
            onClick={preventDefault(() => doRequestProposal(id))}
            size="small"
            startIcon={<DescriptionIcon />}
          >
            Request Proposal
          </Button>
        ))}
    </div>
  )
}

export default SupplierActions
